<template>
  <div :class="wrapClass">
    <div class="image-cover-wrap" v-if="imageModel.hasCrop">
    <picture>
      <source :data-srcset="imageModel.srcSetWebP" type="image/webp" data-sizes="auto" />
      <source :data-srcset="imageModel.srcSet" :type="imageModel.type" data-sizes="auto" />
      <img :src="imageModel.src" :data-src="imageModel.dataSrc" class="image-cover lazyload" :alt="imageModel.altText"
        data-sizes="auto" :style="imageModel.style" />
    </picture>
  </div>
  <img v-if="!imageModel.hasCrop" :src="imageModel.src" :data-src="imageModel.dataSrc" class="image-cover lazyload"
    :alt="imageModel.altText" :style="imageModel.style" />
  </div>
  
</template>

<script>
export default {
  name: "responsiveImage",
  props: ["imageModel","wrapClass"],
};
</script>


// WEBPACK FOOTER //
// src/scripts/vue/components/responsiveImage.vue